export enum EventType {
  DELIVERING_STOP = 'delivering_stop',
  LEAVING_START_LOCATION = 'leaving_start_location',
  REACHING_END_LOCATION = 'reaching_end_location',
  SHIFT_TIME = 'shift_time_banner',
  CLUSTER = 'cluster',
  PAUSED = 'paused',
  IDLING = 'idling',
}
export enum ItemType {
  ROUTE = 'route',
  START_LOCATION = 'start-location',
  END_LOCATION = 'end-location',
  SHIFT_TIME = 'shift-time',
  STOP = 'stop',
  CLUSTER = 'cluster',
  IDLE = 'idle',
  PAUSE = 'pause',
}

export const STOP_NUMBER_SIZE = '8px';
export const STOP_ICON_SIZE = 21;
export const DEPOT_ICON_SIZE = 24;
export const SHIFT_TIME_HEIGHT = 24;
export const DROPZONE_MARKER_HEIGHT = 26;

export const ITEM_BORDER_RADIUS = 8;

export const LINE_HEIGHT = 48;
export const OPACITY_10 = 0.10;
export const OPACITY_15 = 0.15;
export const OPACITY_25 = 0.25;
export const OPACITY_30 = 0.30;
export const OPACITY_50 = 0.50;
export const OPACITY_75 = 0.75;
export const RADIX_BASE_10 = 10;
export const SIDEBAR_WIDTH = 570;

// --- Sidebar row layout (route stats show/collapse) ---
// The row is always laid out at the full SIDEBAR_WIDTH: fixed-width columns in production
// order (color bar, checkbox, name, driver, stats), with the route name absorbing the
// leftover width (and ellipsizing). Collapsing the stats only narrows the sidebar's clip
// edge over this static layout, so the columns slide out of view without ever reflowing —
// that is what keeps the animation a smooth, pure clip/reveal.
export const SIDEBAR_ROW_GAP = 16;
export const SIDEBAR_ROW_RIGHT_PADDING = 16;
export const COLOR_BAR_COLUMN_WIDTH = 4;
export const ROUTE_CHECKBOX_COLUMN_WIDTH = 16;
export const ROUTE_NAME_MIN_COLUMN_WIDTH = 140;
export const DRIVER_COLUMN_WIDTH = 24;
export const STOPS_COLUMN_WIDTH = 50;
export const DISTANCE_COLUMN_WIDTH = 68;
export const WORKING_TIME_COLUMN_WIDTH = 78;
export const CAPACITY_COLUMN_WIDTH = 60;

// Width of the stats section at the right end of the row, including the gap separating it
// from the assigned driver.
export const STATS_SECTION_WIDTH = STOPS_COLUMN_WIDTH + DISTANCE_COLUMN_WIDTH
  + WORKING_TIME_COLUMN_WIDTH + CAPACITY_COLUMN_WIDTH + 4 * SIDEBAR_ROW_GAP;

// Collapse the sidebar so the clip edge lands exactly where the stats section begins:
// the entire stats section sits beyond the divider (nothing peeks), and the assigned
// driver keeps a full row-gap of breathing room before it. Derived, so column tweaks
// can't silently clip the driver again.
export const SIDEBAR_WIDTH_COLLAPSED = SIDEBAR_WIDTH - SIDEBAR_ROW_RIGHT_PADDING
  - STATS_SECTION_WIDTH + SIDEBAR_ROW_GAP;

export const DELIVERY_STOP_PULSE_DELAY_MILLI = 2500;

// Rendered height of the gantt's sticky header row: 16px padding top/bottom around the
// 32px view controller, plus the 1px bottom border (see RouteGanttGroupHeader and the
// .rct-header-root rules in StyledGanttWrapper).
export const HEADER_HEIGHT = 65;
export const CHECKBOX_COLUMN_WIDTH = 40;

export const ZOOM_CONTROL_COMPACT_HEIGHT_BREAKPOINT = 240;
